import {
  Alert,
  alpha,
  Button,
  Divider,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { timezones } from "./fusoHorarios";

export default function EasyLogConfig() {
  const {
    setSubTitle,
    setChanges,
    settings,

    erpErrors,
    setErpErrors,
  } = useOutletContext();
  const theme = useTheme();
  const produto = "easylogs";

  // estados de formulário
  const [linkBanco, setLinkBanco] = useState("");
  const [portBanco, setportBanco] = useState("");
  const [defCGNAT, setDefCGNAT] = useState(false);
  const [timezone, setTimezone] = useState("");
  const [erpStatus, setErpStatus] = useState(false);
  const [servidorErp, setServidorErp] = useState("");
  const [userErp, setUserErp] = useState("");
  const [senhaErp, setSenhaErp] = useState("");
  const [bancoErp, setERP] = useState("");
  const [portaErp, setPortaErp] = useState("");

  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    setSubTitle("EasyLogs");
  }, [setSubTitle]);

  useEffect(() => {
    if (!settings) return;
    let settingsData = settings.find((item) => item.produto === produto);

    setportBanco(settingsData?.configuracoes?.portaBanco || "");
    setLinkBanco(settingsData?.configuracoes?.linkBanco || "");
    setDefCGNAT(settingsData?.configuracoes?.typeBpa || false);
    setTimezone(settingsData?.configuracoes?.timeZone || "America/Sao_Paulo");
    setErpStatus(settingsData?.configuracoes?.erpStatus || false);
    setServidorErp(settingsData?.configuracoes?.servidorErp || "");
    setUserErp(settingsData?.configuracoes?.userErp || "");
    setSenhaErp(settingsData?.configuracoes?.senhaErp || "");
    setERP(settingsData?.configuracoes?.bancoErp || "");
    setPortaErp(settingsData?.configuracoes?.portaErp || "");
  }, [settings]);

  const styles = {
    textFieldSelect: {
      "& .MuiInputBase-input": { fontSize: "0.875rem" },
      "& .MuiOutlinedInput-root": {
        background: alpha(theme.palette.background.paper, 0.7),
        ":hover": { background: alpha(theme.palette.background.paper, 0.9) },
      },
      minWidth: "min-content",
    },
    labels: { fontSize: "14px", fontWeight: 500, color: "text.primary" },
    text: { fontSize: "0.95rem", fontWeight: 500 },
    textFine: {
      fontSize: "0.86rem",
      mt: "-2px",
      color: theme.palette.text.shadow,
    },
    boxOP: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid" + theme.palette.background.paperOutlined,
      p: 2,
      borderRadius: "5px",
    },
    textField: {
      fontSize: "14px",
      width: "100%",
      "& .MuiInputBase-input": {
        fontSize: "0.9rem",
        height: "20px!important",
      },
      '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
      '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
      '& input[type="number"]': { MozAppearance: "textfield" },
      "& .MuiOutlinedInput-root": {
        boxShadow: "none",
        "&.Mui-focused": { boxShadow: "none", border: "none" },
      },
    },
    textAdorment: {
      ml: "-5px",
      fontSize: "0.875em",
      fontWeight: 800,
      color: theme.palette.text.disabled,
      width: "max-content",
    },
    containerPredefinicoes: {
      ml: "0px",
      mr: "0px",
      p: "10px 15px",
      mt: 2,
      width: "100%",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.textField,
    },
  };

  // Handler de salvar com validação

  return (
    <Stack gap={2} mb={8}>
      {/* === Link do Banco === */}
      <Paper sx={styles.boxOP}>
        <Stack direction="column">
          <Typography sx={styles.text}>Banco</Typography>

          <Typography sx={{ ...styles.textFine }}>
            Informe o endereço do banco de registro de logs
          </Typography>

          <Stack justifyContent={"center"} gap={2} mt={1} direction={"row"}>
            <TextField
              fullWidth
              sx={styles.textField}
              onChange={(e) => {
                setChanges((data) => ({
                  product: produto,
                  settings: {
                    ...data?.settings,
                    linkBanco: e.target.value,
                  },
                }));
                setLinkBanco(e.target.value);
              }}
              value={linkBanco}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>IP</Typography>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <TextField
              sx={{ ...styles.textField, width: "150px" }}
              onChange={(e) => {
                setChanges((data) => ({
                  product: produto,
                  settings: {
                    ...data?.settings,
                    portaBanco: e.target.value,
                  },
                }));
                setportBanco(e.target.value);
              }}
              value={portBanco}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>Porta</Typography>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Stack>
          {(!linkBanco || linkBanco == "") && (
            <Alert sx={{ mt: 1 }} severity="info">
              Ainda não possui um banco configurado? Entre em contato com o
              suporte para obter ajuda!
            </Alert>
          )}
        </Stack>
      </Paper>

      {/* === Predefinições (CGNAT, Fuso, ERP) === */}
      <Paper sx={styles.boxOP}>
        <Typography sx={styles.text}>Predefinições</Typography>
        <Stack sx={styles.containerPredefinicoes}>
          {/* Tipo de Log */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack>
              <Typography sx={styles.text}>Tipo de Log</Typography>
              <Typography sx={styles.textFine}>
                Selecione se deseja ativar o CGNAT; caso contrário, o NAT padrão
                será utilizado
              </Typography>
            </Stack>
            <Switch
              size="small"
              checked={defCGNAT}
              onChange={(e) => {
                setDefCGNAT(e.target.checked);
                setChanges((data) => ({
                  product: produto,
                  settings: { ...data?.settings, typeBpa: e.target.checked },
                }));
              }}
            />
          </Stack>

          <Divider sx={{ my: 1 }} />

          {/* Fuso Horário */}
          <Stack
            direction={md ? "row" : "column"}
            alignItems={md ? "center" : "start"}
            justifyContent="space-between"
            gap={2}
          >
            <Stack>
              <Typography sx={styles.text}>Horário Local</Typography>
              <Typography sx={styles.textFine}>
                Informe o seu fuso horário para garantir que os horários
                exibidos estejam corretos de acordo com a sua localização.
              </Typography>
            </Stack>
            <TextField
              sx={styles.textFieldSelect}
              select
              value={timezone}
              size="small"
              onChange={(e) => {
                setTimezone(e.target.value);
                setChanges((data) => ({
                  product: produto,
                  settings: { ...data?.settings, timeZone: e.target.value },
                }));
              }}
            >
              {timezones.map((item) => (
                <MenuItem key={item.value} value={item.query}>
                  {item.zona}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          <Divider sx={{ my: 1 }} />

          {/* Integração ERP */}
          <Stack
            direction="column"
            alignItems={md ? "center" : "start"}
            gap={2}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Stack>
                <Typography sx={styles.text}>Integração com ERP</Typography>
                <Typography sx={styles.textFine}>
                  Ative a integração com o ERP para relacionar os logs com as
                  informações dos seus clientes.
                </Typography>
              </Stack>
              <Switch
                size="small"
                checked={erpStatus}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setErpStatus(checked);
                  // limpa erros se desabilitar ERP
                  if (!checked) {
                    setErpErrors({
                      servidorErp: false,
                      portaErp: false,
                      bancoErp: false,
                      userErp: false,
                      senhaErp: false,
                    });
                  }
                  setChanges((data) => ({
                    product: produto,
                    settings: { ...data?.settings, erpStatus: checked },
                  }));
                }}
              />
            </Stack>

            {erpStatus && (
              <Stack width="100%" gap={2}>
                {/* Tipo de ERP – fixo */}
                <TextField
                  autoComplete="off"
                  sx={{ ...styles.textFieldSelect, width: "200px" }}
                  select
                  value={"ixc"}
                  inputProps={{ readOnly: true }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography sx={styles.textAdorment}>ERP</Typography>
                        </InputAdornment>
                      ),
                    },
                  }}
                >
                  <MenuItem value="ixc">IXC</MenuItem>
                </TextField>

                {/* Servidor e Porta */}
                <Stack direction="row" gap={2}>
                  <TextField
                    value={servidorErp}
                    autoComplete="off"
                    size="small"
                    fullWidth
                    error={erpErrors.servidorErp}
                    helperText={
                      erpErrors.servidorErp ? "Preencha o servidor ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setServidorErp(v);
                      setChanges((data) => ({
                        product: produto,
                        settings: { ...data?.settings, servidorErp: v },
                      }));
                      if (v && erpErrors.servidorErp) {
                        setErpErrors((p) => ({ ...p, servidorErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Servidor
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <TextField
                    value={portaErp}
                    autoComplete="off"
                    size="small"
                    type="number"
                    error={erpErrors.portaErp}
                    helperText={
                      erpErrors.portaErp ? "Preencha a porta do ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setPortaErp(v);
                      setChanges((data) => ({
                        product: produto,
                        settings: { ...data?.settings, portaErp: v },
                      }));
                      if (v && erpErrors.portaErp) {
                        setErpErrors((p) => ({ ...p, portaErp: false }));
                      }
                    }}
                    sx={{ ...styles.textFieldSelect, width: "150px" }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Porta
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>

                {/* Banco */}
                <TextField
                  value={bancoErp}
                  autoComplete="off"
                  size="small"
                  fullWidth
                  error={erpErrors.bancoErp}
                  helperText={erpErrors.bancoErp ? "Preencha o banco ERP" : ""}
                  onChange={(e) => {
                    const v = e.target.value.trim();
                    setERP(v);
                    setChanges((data) => ({
                      product: produto,
                      settings: { ...data?.settings, bancoErp: v },
                    }));
                    if (v && erpErrors.bancoErp) {
                      setErpErrors((p) => ({ ...p, bancoErp: false }));
                    }
                  }}
                  sx={styles.textFieldSelect}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography sx={styles.textAdorment}>
                            Banco
                          </Typography>
                        </InputAdornment>
                      ),
                    },
                  }}
                />

                {/* Usuário e Senha */}
                <Stack direction="row" gap={2}>
                  <TextField
                    value={userErp}
                    autoComplete="off"
                    size="small"
                    fullWidth
                    error={erpErrors.userErp}
                    helperText={
                      erpErrors.userErp ? "Preencha o usuário ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setUserErp(v);
                      setChanges((data) => ({
                        product: produto,
                        settings: { ...data?.settings, userErp: v },
                      }));
                      if (v && erpErrors.userErp) {
                        setErpErrors((p) => ({ ...p, userErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Usuário
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <TextField
                    value={senhaErp}
                    autoComplete="off"
                    size="small"
                    type="password"
                    fullWidth
                    error={erpErrors.senhaErp}
                    helperText={
                      erpErrors.senhaErp ? "Preencha a senha ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setSenhaErp(v);
                      setChanges((data) => ({
                        product: produto,
                        settings: { ...data?.settings, senhaErp: v },
                      }));
                      if (v && erpErrors.senhaErp) {
                        setErpErrors((p) => ({ ...p, senhaErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Senha
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}
